/**
 * @file    CprRollupSection.tsx
 * @scope   ENTERPRISE
 * @summary Main-tab host section for the Cross-Program Rollup subtype.
 * @consumes EngineSectionProps, MetricsManager
 * @produces CprRollupSection
 * @sideEffects Opens the CPR Manage Programs view (sets the drawer's CPR programs context).
 * @notes   Trend is handled by the shared drawer trend control (`useCprTrendSync`).
 */
import React, { useState } from 'react';
import Accordion from 'core-ui/accordionDrawer/accordionDrawer';
import { useCprContext } from 'components/DiyWidgetEngine/Subtypes/CrossProgramRollup/state/CprContext';
import { ProgramsManagerTab } from 'components/DiyWidgetEngine/Subtypes/CrossProgramRollup/Views/ProgramsManager/programsManagerModel';
import MetricsManager from 'components/DiyWidgetEngine/Subtypes/CrossProgramRollup/Views/MetricsManager/MetricsManager';
import type { EngineSectionProps } from './engineSectionRegistry';
import { useCprNavigation } from '../plugins/cpr/CprNavigationContext';
import './CprRollupSection.scss';

const CprRollupSection: React.FC<EngineSectionProps> = ({ setCurrentTab }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { state } = useCprContext();
  const { setCprProgramsContext } = useCprNavigation();

  const openProgramsView = (rollupId: string) => {
    const rollup = state.metrics.find((m) => m.id === rollupId);
    if (!rollup) return;
    setCprProgramsContext({ rollupId, programId: null, focusedFilterId: null, snapshot: rollup });
    setCurrentTab(ProgramsManagerTab);
  };

  return (
    <div className="diy-drawer-section cpr-rollup-section">
      <Accordion
        title="Cross Program Rollup Metrics"
        isExpanded={isExpanded}
        onToggle={setIsExpanded}
      >
        <MetricsManager onManagePrograms={openProgramsView} />
      </Accordion>
    </div>
  );
};

export default React.memo(CprRollupSection);
